<template lang="pug">
  main
    section.section
      .container
        h3.title.is-3 Lista de Verificación para Carga de Gas LP de Autotanques
        .columns
          .column.is-half
            .card
              header.card-header
                p.card-header-title Id Veridicación: {{ verificacionActual.id }}
              .card-content
                .content
                  p 📅 Fecha Recepción: {{ verificacionActual.fechaRecepcion }}
                  p 🚚 Operador: {{ verificacionActual.nombreOperador }}
                  p 👷 Verificador: {{ verificacionActual.nombreVerificador }}
          .column.is-half
            .card
              header.card-header
                p.card-header-title Autotanques Verificados
              .card-content
                .content
                  div.pgsEmplazados(v-for="tanque in autotanques" :key="tanque.id")
                    a.button(
                      @click="imprimirFormato(tanque)"
                      :class="{'is-danger': tanque.emplazado, 'is-light': !tanque.emplazado}"
                    )
                      span.icon
                        i.fas.fa-print
                      span {{ tanque.pg }}
        .columns
          button.button.is-primary.is-large.is-fullwidth(@click="finishEntrada") Terminar
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Emplazados',
  data () {
    return {
      emplazados: []
    }
  },
  methods: {
    imprimirFormato (tanque) {
      if (tanque.emplazado) {
        console.log('Crear Hoja Emplazado')
      } else {
        console.log('Crear Hoja Entrada Normal')
      }
    },
    finishEntrada () {
      this.$store.commit('resetTanques')
      this.$store.commit('verificacionComplete', false)
      this.$router.push('/IRGE/Accesos_IRGE')
    }
  },
  created () {
  },
  computed: {
    ...mapState(['autotanques', 'verificacionActual'])
  }
}
</script>

<style scoped>
 .pgsEmplazados {
   margin-top: 5px;
   margin-bottom: 5px;
 }
</style>




// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/Emplazados.vue